/**
 * Read query parameters without a dependency.
 *
 * The app used query-string for exactly one thing: parse(location.search), in
 * thirteen places. The package carried its own advisory and its fixed line is
 * ESM-only, which CRA 5 does not take well. URLSearchParams is built in and does
 * the same job. (Sovellon #2260, finding F-13.)
 *
 * Repeated keys collapse to the last value, which matches how these call sites use
 * it: they read single-valued tokens and identifiers out of a redirect URL.
 */
export const parseQuery = (search) => {
  if (!search) {
    return {};
  }
  const params = new URLSearchParams(String(search).replace(/^\?/, ''));
  const result = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};

export default { parse: parseQuery };
